export default {
  questions: [
    {
      questionId: 1,
      questionText:
        "โปรดเลือก...",
      choices: [
        { choiceId: "A", text: "ท่านรู้ว่าตัวเองเป็นคนแบบไหน และไม่มีอะไรสามารถเปลี่ยนแปลงมันได้" },
        { choiceId: "B", text: "ไม่ว่าท่านจะเป็นคนแบบไหน ท่านสามารถเปลี่ยนแปลงตัวเองได้อย่างมหาศาล" },
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 2,
      questionText:
        "โปรดเลือก...",
      choices: [
        { choiceId: "A", text: "ท่านสามารถเปลี่ยนแปลงวิธีทำสิ่งต่าง ๆ ได้ แต่ตัวตนของท่านซึ่งเป็นส่วนสำคัญนั้นไม่สามารถเปลี่ยนแปลงได้จริง ๆ" },
        { choiceId: "B", text: "ท่านสามารถเปลี่ยนแปลงคุณสมบัติพื้นฐานเกี่ยวกับตัวตนของท่านได้เสมอ" },
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 3,
      questionText:
        "โปรดเลือก...",
      choices: [
        { choiceId: "A", text: "ความฉลาดเป็นคุณสมบัติที่ติดตัวมาแต่เกิด ซึ่งไม่สามารถเปลี่ยนแปลงได้" },
        { choiceId: "B", text: "ไม่ว่าคุณจะฉลาดแค่ไหน คุณก็สามารถพัฒนาตัวเองให้ฉลาดขึ้นอีกเล็กน้อยได้" },
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    },
    {
      questionId: 4,
      questionText:
        "โปรดเลือก...",
      choices: [
        { choiceId: "A", text: "คุณเรียนรู้สิ่งใหม่ ๆ ได้ แต่พัฒนาตัวเองให้ฉลาดขึ้นไม่ได้" },
        { choiceId: "B", text: "คุณสามารถพัฒนาตัวเองให้ฉลาดขึ้นได้อย่างมหาศาล" },
      ],
      showAnswer: false,
      correctedAnswer: "",
      userAnswer: ""
    }
  ]
};
